// import { action, computed, makeObservable, observable } from "mobx";
// import { nanoid } from "nanoid";
// import { COMPONENT_TYPES } from "../../../helpers/enums";

// const EXPERIMENT_ROOM_ID = "eEJ9fWfJ5E2iGiJ02k8YR";

export class SpaceStore {}
